import { useEffect } from "react";

interface Props {
  onClose: () => void;
}

interface ShortcutGroup {
  title: string;
  items: Array<{ keys: string[]; label: string }>;
}

const GROUPS: ShortcutGroup[] = [
  {
    title: "ファイル / 保存",
    items: [
      { keys: ["Ctrl", "S"], label: "保存(自動保存に加えて即時)" },
      { keys: ["Ctrl", "Z"], label: "アンドゥ(グリッド・manifest 編集)" },
      { keys: ["Ctrl", "Y"], label: "リドゥ" },
      { keys: ["Ctrl", "Shift", "Z"], label: "リドゥ(別バインド)" },
    ],
  },
  {
    title: "検索 / ナビゲーション",
    items: [
      { keys: ["Ctrl", "Shift", "F"], label: "全ファイル検索・置換" },
      { keys: ["F1"], label: "このショートカット一覧を開く" },
      { keys: ["?"], label: "このショートカット一覧を開く" },
      { keys: ["Esc"], label: "開いているモーダル / メニューを閉じる" },
    ],
  },
  {
    title: "プレビュー / 実行",
    items: [
      { keys: ["F5"], label: "プレビューに送信して実行" },
      { keys: ["F12"], label: "選択行のジャンプ先(ラベル定義)へ移動" },
    ],
  },
  {
    title: "グリッド編集",
    items: [
      { keys: ["#番号セル", "ドラッグ"], label: "行を並び替え" },
      { keys: ["右クリック"], label: "コンテキストメニュー" },
      { keys: ["セルクリック"], label: "BGM / 背景 / 立ち絵 を直接編集" },
      { keys: ["メッセージダブルクリック"], label: "メッセージ編集モーダル" },
    ],
  },
  {
    title: "ファイル管理",
    items: [
      { keys: ["FILES の ＋"], label: "新規ファイル" },
      { keys: ["ダブルクリック"], label: "ファイル名リネーム(インライン)" },
      { keys: ["ホバー時の ✕"], label: "ファイル削除" },
    ],
  },
];

export function ShortcutsModal({ onClose }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div
        className="modal modal-shortcuts"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h2>キーボードショートカット</h2>
        <div className="sc-groups">
          {GROUPS.map((g) => (
            <section className="sc-group" key={g.title}>
              <h3>{g.title}</h3>
              <ul>
                {g.items.map((it, i) => (
                  <li key={i}>
                    <span className="sc-keys">
                      {it.keys.map((k, j) => (
                        <span key={j} className="kbd">
                          {k}
                        </span>
                      ))}
                    </span>
                    <span className="sc-label">{it.label}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
}
